exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".RLX-Footer {\n  margin: 0 auto;\n  text-align: center;\n  font-weight: 300; }\n  .RLX-Footer p {\n    color: #b9b9b9; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Views/Dashboard/Footer/Footer.scss
// module id = 406
// module chunks = 0